// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__3GYuf","ant-card-body":"styles_ant-card-body__2gHUk"};